import Vue from 'vue';
import App from './App.vue';
import Snotify from 'vue-snotify';
import Moment from 'moment';
import store from './store';
import router from './router';
import VeeValidate, { Validator, ValidationProvider } from 'vee-validate';

import ru from 'vee-validate/dist/locale/ru';

import '@/assets/styles/base.scss';
import 'vue-snotify/styles/material.css';

import Multiselect from 'vue-multiselect';
import Loader from '@/components/common/Loader.vue';
import Paginator from '@/components/common/Paginator.vue';
import InnerNavigation from '@/components/common/InnerNavigation.vue';

Vue.component('loader', Loader);
Vue.component('paginator', Paginator);
Vue.component('multiselect', Multiselect);
Vue.component('inner-navigation', InnerNavigation);
Vue.component('ValidationProvider', ValidationProvider);

Vue.use(Snotify);
Vue.use(VeeValidate);
Validator.localize('ru', ru);

Moment.locale('ru');

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
